import { useNavigate, useSearchParams } from "react-router-dom";
import crypto from 'crypto-js';
import Loader from "../../components/loader";
import { useEffect } from "react";
import { verifyInvite } from "../../api/activation";
import { SHOW_TOAST } from "../../constant/utils";

const secretKey = process.env.REACT_APP_ACTIVATION_SECRET_KEY || '';

const decryptData = (encrypted) => {
    try {

        if (!secretKey) throw new Error('Secret key is missing');

        const bytes = crypto.AES.decrypt(decodeURIComponent(encrypted), secretKey);

        return JSON.parse(bytes.toString(crypto.enc.Utf8));
    } catch (error) {
        return null;
    }
};

export default function ActivationVerification() {
    const [searchParams, setSearchParams] = useSearchParams();
    const token = searchParams.get("token");
    const navigate = useNavigate()

    useEffect(() => {
        const redirectTimer = setTimeout(() => {
            navigate("/login")
        }, 10000);

        return () => {
            clearTimeout(redirectTimer);
        };
    }, [navigate]);


    useEffect(() => {
        localStorage.removeItem("user")
        if (!token) {

            navigate("/login")
            return;
        }

        const validateInvite = async () => {
            const decrypted = decryptData(token);
            if (!decrypted) {
                navigate("/login")
                return;
            }

            const { clientId, licenseId, email } = decrypted
            const user = await verifyInvite(clientId, licenseId);

            if (!user) {
                SHOW_TOAST("The link has expired.")
                navigate("/login")
                return;
            } else {
                localStorage.setItem("user", JSON.stringify(decrypted))
                navigate("/signup/activation")
            }
        };

        validateInvite();
    }, [token]);


    return (
        <div>
            <Loader />
        </div>

    )
}